import { useQuery } from '@tanstack/react-query';
import { API } from '../services/api';

export interface Space {
  id: string;
  name: string;
  slug: string;
  description?: string;
  logo?: string;
  icon?: string;
  role?: string;
}

export const useSpaces = () => {
  return useQuery({
    queryKey: ['spaces'],
    queryFn: async () => {
      const data = await API.spaces.getAll();
      return data.spaces;
    },
  });
};

export const useSpace = (slug: string) => {
  return useQuery({
    queryKey: ['spaces', slug],
    queryFn: async () => {
      const data = await API.spaces.get(slug);
      return data.space;
    },
    enabled: !!slug,
  });
};
